import { render, staticRenderFns } from "./PublishDialog.vue?vue&type=template&id=103081bd&scoped=true"
import script from "./PublishDialog.vue?vue&type=script&lang=js"
export * from "./PublishDialog.vue?vue&type=script&lang=js"
import style0 from "./PublishDialog.vue?vue&type=style&index=0&id=103081bd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103081bd",
  null
  
)

export default component.exports